export default {
  "sub-container": "_sub-container_vxt9f2",
  "account-container": "_account-container_vxt9f2",
  "balance-value": "_balance-value_vxt9f2",
  "account-name": "_account-name_vxt9f2"
};
